module.exports = __webpack_public_path__ + "img/tarif-check.9d297215.svg";